export function isIe() {
  return /MSIE \d|Trident.*rv:/.test(navigator.userAgent);
}
